import { withMonitoring } from '../monitoring/withMonitoring'
import { httpClient } from './httpClient'

export const isDomainSupportVoucher = async (domain: string) => {
  const request = () =>
    httpClient.get<{ isVoucherSupported: boolean }>(`/isDomainSupportVoucher?domain=${encodeURIComponent(domain)}`)
  return withMonitoring(request, 'suggestDomains')
}
